import { useEffect, useRef } from 'react';

const TOKEN_REFRESH_BUFFER = 60; // seconds

export type UnixTimestampString = `${number}`;

const isValidUnixTimestampString = (
  value: unknown,
): value is UnixTimestampString =>
  typeof value === 'string' && /^\d+$/.test(value);

const useIntercomTokenRefresh = (
  expiresAt: UnixTimestampString | undefined,
  refetch: () => void,
): void => {
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const cleanup = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
  };

  useEffect(() => {
    if (!isValidUnixTimestampString(expiresAt)) return undefined;
    const now = Math.floor(Date.now() / 1000);
    const secondsUntilRefresh = Math.max(
      Number(expiresAt) - now - TOKEN_REFRESH_BUFFER,
      0,
    );

    cleanup();

    timerRef.current = setTimeout(() => {
      refetch();
    }, secondsUntilRefresh * 1000);

    return cleanup;
  }, [expiresAt, refetch]);
};

export default useIntercomTokenRefresh;
